<template>
<div >
  <div class="form-group">
    <label for="brand"><strong>MARCHIO</strong></label>
      <select ref="name" id="brand" :required="props.required" @change="$emit('update',brandId,$event)" class="form-control" v-model="brandId" >
        <option v-if="props.allBrands" :value="'%'">TUTTI</option> 
        <option v-for="(item,index) in items" :value="item.brand" :key="index">{{item.brand}} </option>        
      </select>  
  </div>  
</div>

</template>
<script>
import api             from "@/api";
import { mapGetters }    from 'vuex';


export default {
  props : ['props'] , 
  components: {},
  data() {
    return {
     
      brandId                : '%',
      items                  : [],
      spinner                : false
     
    };
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  computed:
  {
      ...mapGetters(['company']) 
  }, 
  mounted: function() {
    this.focusInput();
  },
  created: function() {
      
    this.getData()
       
      
  },
  methods: 
  {
    focusInput() {
      if(this.props.focus)  
      {
        this.$refs.name.focus();
      }

    },
    async getData()
    {
      this.items = []      
      var sp   = {'sp'         : 'spCompanyBrandList'}      
      var data = {'companyId'  : this.company.Id}
      var json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
                   
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              
            }
           else if(res.status==500)
           {
                console.log(res.data)
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
    
 



     
    },
  
    
    
  
}

}
</script>
<style scoped>

</style>